import TabsWithDots from 'components/TabsWithDots/TabsWithDots';
import { translate } from 'components/Translation';
import React, { Suspense, useState } from 'react';
import BillsList from '../BillsList';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/myBillsStyle';
import { BILLS_LIST, STEPS } from '../constants';
import { PayWith, PaymentStatus, PaymentStatusType } from 'components/PaymentMethod';
import { useHistory } from 'react-router-dom';

const PaymentMethodComponent = React.lazy(() => import('components/PaymentMethod'));

// @ts-ignore
const useStyles = makeStyles(styles);
const MyBills = (props: any) => {
	const classes = useStyles();
	const history = useHistory();
	const query = new URLSearchParams(history.location.search);

	const [activeTab, setActiveTab] = useState(STEPS.MY_BILLS);
	const [paymentResult, setPaymentResult] = useState<{ status: PaymentStatusType; refNumber: string }>({
		status: PaymentStatusType.ERROR,
		refNumber: '',
	});
	const [paymentData, setPaymentData] = useState<types.payment.paymentItem[]>([]);

	const onPaymentResult = (result: PaymentStatusType, response: any) => {
		setPaymentResult({
			status: result,
			refNumber: response?.transactionReferenceNumber ?? response?.ticketNumber ?? '',
		});
		setActiveTab(STEPS.CONFIRMATION);
	};

	return (
		<TabsWithDots
			tabs={[
				{
					name: translate('payments.bills.header'),
					// Disabled steps because, after payment initiation, there is no need to revert back to the previous step
					disabled: activeTab === STEPS.CONFIRMATION,
					content: <BillsList {...props} setActiveTab={setActiveTab} setPaymentData={setPaymentData} />,
				},
				{
					name: translate('payments.method'),
					// Disabled steps because, after payment initiation, there is no need to revert back to the previous step
					disabled: activeTab === STEPS.CONFIRMATION,
					content: (
						<Suspense fallback={'loading...'}>
							<PaymentMethodComponent
								bills={paymentData}
								paymentPreference={(query.get('paymentPreference') as PayWith) ?? undefined}
								onPaymentResult={onPaymentResult}
								referrer={BILLS_LIST}
							/>
						</Suspense>
					),
				},
				{
					name: translate('confirmation'),
					content: <PaymentStatus status={paymentResult.status} RefNumber={paymentResult.refNumber} />,
				},
			]}
			activeTab={activeTab}
			setActiveTab={setActiveTab}
			wrapperClass={classes.contentWrapper}
		/>
	);
};

export default MyBills;
